module.exports = __webpack_public_path__ + "assets/img/dfa-cx.688323d3.png";